import React, { useState, useRef } from "react";
import { Container } from "react-bootstrap";
import emailjs from '@emailjs/browser';
import MobileNavigationBar from "../components/mobileNavbar";
import MobileFooter from "../components/mobileFooter";

export const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        address: '',
        apartmentNumber: '',
        apartmentComplexName: '',
        maritalStatus: '',
        domesticViolence: '',
        dateOfBirth: '',
        gender: '',
        briefDescriptionOfNeed: '',
        city: '',
        state: '',
        zipCode: ''
    });
    const [status, setStatus] = useState('');
    const contactRef = null;
    const form = useRef();
    


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        const { firstName, lastName, phoneNumber, email, address, maritalStatus, domesticViolence, dateOfBirth, gender, briefDescriptionOfNeed, apartmentComplexName, apartmentNumber, city, state, zipCode } = formData;
        if (!firstName || !lastName || !phoneNumber || !email || !address || !maritalStatus || !domesticViolence || !dateOfBirth || !gender || !briefDescriptionOfNeed || !apartmentComplexName || !apartmentNumber || !city || !state || !zipCode) {
            setStatus("Please fill in all required fields.");
            return;
        }

        emailjs.sendForm('service_82cqu5m', 'template_g5mrxid', form.current, 'R52Iz57wHs8oq5df_')
            .then(
                () => {
                    setStatus("Message sent successfully!");
                    setFormData({
                        firstName: '',
                        lastName: '',
                        phoneNumber: '',
                        email: '',
                        address: '',
                        apartmentNumber: '',
                        apartmentComplexName: '',
                                maritalStatus: '',
                                domesticViolence: '',
                                dateOfBirth: '',
                        gender: '',
                        briefDescriptionOfNeed: '',
                        city: '',
                        state: '',
                        zipCode: ''
                    });
                },
                (error) => {
                    setStatus("There was an error sending your message.");
                    console.log("EmailJS error:", error.text);
                }
            );
    };

    return (
        <div style={{ backgroundColor: '#f4f4f4' }}>
            <MobileNavigationBar />

            <Container className="my-3">
                <div id="contactus">
                    <h2>For General Questions: </h2>
                    <div style={{
                        backgroundColor: '#839e6c',
                        borderRadius: '15px',
                        padding: '20px',
                        color: 'white',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    }}>
                        <form ref={form} onSubmit={handleSubmit}>

                            {/* First and Last Name */}
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} placeholder="First Name *" required style={inputStyle} />
                                <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Last Name *" required style={inputStyle} />
                            </div>

                            {/* Phone and Email */}
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <input type="tel" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} placeholder="Phone Number *" required style={inputStyle} />
                                <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address *" required style={inputStyle} />
                            </div>

                            {/* Address */}
                            <input type="text" name="address" value={formData.address} onChange={handleChange} placeholder="Address *" required style={inputStyle} />

                            {/* Apartment Number and Complex Name */}
                            <input type="text" name="apartmentNumber" value={formData.apartmentNumber} onChange={handleChange} placeholder="Apartment Number" required style={inputStyle} />
                            <input type="text" name="apartmentComplexName" value={formData.apartmentComplexName} onChange={handleChange} placeholder="Apartment Complex Name" required style={inputStyle} />

                            {/* City, State, and Zip Code */}
                            <input type="text" name="city" value={formData.city} onChange={handleChange} placeholder="City *" required style={inputStyle} />
                            <input type="text" name="state" value={formData.state} onChange={handleChange} placeholder="State *" required style={inputStyle} />
                            <input type="text" name="zipCode" value={formData.zipCode} onChange={handleChange} placeholder="Zip Code *" required style={inputStyle} />

                            {/* Marital Status */}
                            <select name="maritalStatus" value={formData.maritalStatus} onChange={handleChange} required style={inputStyle}>
                                <option value="">Marital Status *</option>
                                <option value="Married">Married</option>
                                <option value="Single">Single</option>
                                <option value="Separated">Separated</option>
                            </select>

                            {/* Domestic Violence Case */}
                            <select name="domesticViolence" value={formData.domesticViolence} onChange={handleChange} required style={inputStyle}>
                                <option value="">Domestic Violence Case*</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>

                            {/* Gender */}
                            <select name="gender" value={formData.gender} onChange={handleChange} required style={inputStyle}>
                                <option value="">Gender *</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                            {/* Date of Birth */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <p style={{ margin: 0 }}>DOB:</p>
                                <input
                                    type="date"
                                    name="dateOfBirth"
                                    value={formData.dateOfBirth}
                                    onChange={handleChange}
                                    required
                                    style={inputStyle}
                                />
                            </div>

                            {/* Message */}
                            <textarea
                                name="briefDescriptionOfNeed"
                                value={formData.briefDescriptionOfNeed}
                                onChange={handleChange}
                                placeholder="Briefly describe what you need help with *"
                                required
                                style={{ ...inputStyle, minHeight: '150px' }}
                            />

                            {/* Submit */}
                            <button type="submit" style={buttonStyle}>
                                Send
                            </button>

                        </form>

                        {/* Status Message */}
                        {status && <p style={{ color: '#fff', fontWeight: 'bold', textAlign: 'center', marginTop: '20px' }}>{status}</p>}
                    </div>
                </div>
            </Container>
            <MobileFooter />
        </div>
    );
};

// Styles
const inputStyle = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: 'white',
    color: 'black',
};

const buttonStyle = {
    backgroundColor: '#fff',
    color: '#30572C',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '10px',
};

export default Contact;
